import { createComponent } from '@carvana/merch-components';

export const CoSignerContent = createComponent('div', {
  className: 'flex flex-wrap items-center gap-xl self-stretch'
});

export const Avatar = createComponent('div', {
  className:
    'flex h-48 w-48 shrink-0 items-center justify-center rounded-round bg-background-warning'
});

export const Initials = createComponent('span', {
  className:
    'flex h-[18px] w-48 shrink-0 flex-col justify-center text-center text-text-strong t-label-lg'
});

export const CoSignerDetails = createComponent('div', {
  className: 'flex flex-col items-start gap-md'
});

export const Name = createComponent('span', {
  className: 'text-text-strong t-heading-xs'
});
